export interface AppConfig {
  title: string;
  vietnameseTitle: string;
  chineseTitle: string;
  tagline: string;
  version: string;
  storageKey: string;
  contactEmail: string;
  defaultScene: string;
}

export const APP_CONFIG: AppConfig = {
  title: 'Yunnan Dreamscape',
  vietnameseTitle: 'Mộng Vân Nam',
  chineseTitle: '彩云之境',
  tagline: 'Living 3D Diorama & Gentle Soundscapes',
  version: '0.1.0',
  storageKey: 'yunnan_dreamscape_settings_v1',
  contactEmail: 'diplamtuan@gmail.com',
  defaultScene: 'yulong',
};
